import React from "react";
import twoLogos from "../images/twoLogos.svg";
import twoLogosWhite from "../images/twoLogosWhite.svg";
import logoInstagram from "../images/logoInstagram.svg";
import logoInstagramWhite from "../images/logoInstagramWhite.svg";
import logoTelegram from "../images/logoTelegram.svg";
import logoTelegramWhite from "../images/logoTelegramWhite.svg";
import logoPinterest from "../images/logoPinterest.svg";
import logoPinterestWhite from "../images/logoPinterestWhite.svg";
import {
    INSTAGRAM_APP_LINK,
    INSTAGRAM_LINK,
    PINTEREST_LINK,
    TELEGRAM_LINK,
} from "../constants/constants";
import { Link } from "react-router-dom";
import { isMobileUserAgent } from "../helpers/helpers";

function Footer({ containerClassNames = "bg-custom-yellow", isDark = false }) {
    return (
        <footer
            className={`${containerClassNames} flex flex-col lg:flex-row lg:justify-between items-center lg:px-24 pt-5 lg:pt-0 mt-16 xl:mt-36`}
            role="contentinfo"
            aria-label="Site footer"
        >
            <div>
                <Link to="/">
                    <img
                        src={isDark ? twoLogosWhite : twoLogos}
                        className="max-w-32 lg:max-w-none lg:w-72"
                        alt="ЦАЦКИ ХЮФ"
                    />
                </Link>
            </div>

            <div className="flex flex-col lg:flex-row items-center">
                <div
                    className={`lg:text-3xl text-center flex flex-col lg:text-right mt-4 pb-4 border-b-2 lg:border-b-0 ${
                        isDark
                            ? "border-white text-white"
                            : "border-black text-black"
                    } lg:pr-6`}
                >
                    <span>Підписуйтесь на</span>
                    <span>наші соціальні мережі</span>
                </div>
                <div
                    className={`flex lg:flex-col gap-5 mt-4 lg:mt-6 mb-6 lg:border-l-2 ${
                        isDark ? "border-white" : "border-black"
                    } lg:pl-6`}
                >
                    <div className="text-center max-w-16 lg:max-w-none">
                        <Link target="blank" to={isMobileUserAgent()
                            ? INSTAGRAM_APP_LINK
                            : INSTAGRAM_LINK}>
                            <img
                                src={
                                    isDark ? logoInstagramWhite : logoInstagram
                                }
                                alt="Instagram"
                            />
                        </Link>
                    </div>

                    <div className="text-center max-w-16 lg:max-w-none">
                        <Link target="blank" to={TELEGRAM_LINK}>
                            <img
                                src={isDark ? logoTelegramWhite : logoTelegram}
                                alt="Telegram"
                            />
                        </Link>
                    </div>

                    <div className="text-center max-w-16 lg:max-w-none">
                        <Link target="blank" to={PINTEREST_LINK}>
                            <img
                                src={
                                    isDark ? logoPinterestWhite : logoPinterest
                                }
                                alt="Pinterest"
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
